const regex = new RegExp(/^(([A-z0-9]{12}[0-9]{5})|([A-z0-9- ]{3,7}[0-9- ] {3,7}))$/)

export function isValidYQVin(vinToCheck: string) {
    return vinToCheck.length > 0 && regex.test(vinToCheck)
}
